import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import NotificationSchema from '../schemas/NotificationSchema'
import ajax from '@get-bridge/learn-legacy-shared/dist/utils/ajax'

export default DataRequest({
  schema: NotificationSchema,

  perform(notification) {
    return ajax({
      url: `/api/learner/notifications/${notification.id}`,
      type: 'PUT',
      data: notification
    })
  },
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/notifications/data_requests/updateNotification.js